<div class="import-panel flex flex-col items-center gap-6 p-8">
  <div class="import-intro flex flex-col items-center gap-1 text-center">
    <mat-icon class="material-symbols-rounded import-intro-icon">cloud_upload</mat-icon>
    <h3 class="import-title">Import issues from a spreadsheet</h3>
    <p class="import-subtitle">
      Download the XLSX template, fill in your issues, then upload it to import
      them in bulk.
    </p>
  </div>

  <div class="flex flex-wrap items-center justify-center gap-3">
    <button mat-stroked-button color="primary" (click)="downloadExcel()">
      <mat-icon class="material-symbols-rounded">download</mat-icon>
      Download template
    </button>

    <input
      type="file"
      accept=".xlsx"
      class="file-input"
      (change)="uploadIssue($event)"
      #fileUpload
    />
    <button mat-flat-button color="accent" (click)="fileUpload.click()">
      <mat-icon class="material-symbols-rounded">upload</mat-icon>
      Upload XLSX
    </button>
  </div>
</div>
